import predicates from '../predicates'
import selectors from '../selectors'
import { PARTNER_TRAFFIC_SOURCE } from '../constants'

const trPartner = {
  rule: predicates.and(
    predicates.searchParamEqualsOne('utm_medium', 'tr_partner'),
    predicates.searchParamsIncludeOne('utm_source')
  ),
  extractor: traffic => {
    const trafficSource = PARTNER_TRAFFIC_SOURCE
    const trafficId = selectors.searchParamValue(traffic, 'utm_source')

    return {
      trafficSource,
      trafficId,
    }
  },
}

export default trPartner



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/pipelines/trPartner.js